import styles from './style.module.css';
import Modal from 'react-responsive-modal';
import { Button } from '../../../../components/Button';
import { withStyles } from '@material-ui/core/styles';
import { Rating } from '@mui/material';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import StarRateIcon from '@mui/icons-material/StarRate';
import StarOutlineIcon from '@mui/icons-material/StarOutline';
import avatarImg from '../../../../assets/images/avatar.png';
import trophy from '../../../../assets/images/step-4.png';

interface IModalContact {
  modalIsOpen: boolean;
  player: any;
  toggleModal: () => void;
  clientUrl?: string;
  isAutoIndicate?: boolean;
  customText?: string;
  postRating?: any;
  actionMgm?: string;
  actionMgmCta?: string;
  actionMgmRedirect?: string;
}

const StyledRating = withStyles({
  iconFilled: {
    color: '#ffc107',
  },
})(Rating);

export function ModalContact({
  modalIsOpen,
  player,
  toggleModal,
  clientUrl,
  isAutoIndicate,
  customText,
  postRating,
  actionMgm,
  actionMgmCta,
  actionMgmRedirect,
}: IModalContact) {
  const navigate = useNavigate();
  const [voted, setVoted] = useState(false);
  return (
    <Modal open={modalIsOpen} onClose={toggleModal} center>
      <div className="contents-modal">
        <div className="d-flex justify-content-center">
          <img
            className="rounded rounded-circle"
            src={player?.photoURL ? player?.photoURL : avatarImg}
            alt="Imagem de perfil"
            width={70}
          />
        </div>
        <h1 className="title-modal">Obrigado(a)</h1>
        {clientUrl === 'vivaz' && (
          <p className="subtitle-modal">
            Em breve você receberá uma mensagem do nosso Whatsapp para confirmar
            a indicação! Fique de olho e boa sorte na compra do seu Apê!
          </p>
        )}
        {clientUrl !== 'vivaz' && (
          <>
            {!isAutoIndicate && (
              <p className="subtitle-modal">Em breve entraremos em contato!</p>
            )}
            {customText && <p className="subtitle-modal">{customText}</p>}
          </>
        )}
        <p className="subtitle-modal fw-bold">
          Avalie a indicação de {player && player.name}
        </p>
        <div className="d-flex justify-content-center">
          <StyledRating
            defaultValue={null}
            precision={0.5}
            onChange={(e, newValue) => {
              postRating(newValue);
              setVoted(true);
            }}
            icon={
              <StarRateIcon
                style={{ width: '32px', height: '32px' }}
              ></StarRateIcon>
            }
            emptyIcon={
              <StarOutlineIcon
                style={{ width: '32px', height: '32px' }}
              ></StarOutlineIcon>
            }
            disabled={voted}
          />
        </div>
        {voted && <p className="subtitle-modal">Obrigado por sua avaliação!</p>}
        {actionMgm && actionMgm === 'true' && (
          <div className="d-flex align-items-center text flex-column mt-3">
            <p className="subtitle-modal fw-bold">
              Quer ganhar prêmio indicando a {clientUrl} para amigos?
            </p>
            <img
              className="rounded rounded-circle"
              src={trophy}
              alt="Troféu"
              width={70}
            />
          </div>
        )}
      </div>
      <div className={styles.contentBtn}>
        <Button
          isModal
          text={actionMgm && actionMgmCta ? actionMgmCta : 'Concluir'}
          type="button"
          color="primary"
          onClick={() => {
            if (actionMgm) {
              navigate(actionMgmRedirect);
            } else {
              toggleModal();
            }
          }}
        />
      </div>
    </Modal>
  );
}
